import type {
  LivestockInfo,
  LivestockInfoFromFarm,
  WeightGainCurve,
} from "shared/types";

export const LIST_FARM_WEIGHT_GAIN_CURVES = "LIST_FARM_WEIGHT_GAIN_CURVES";
export const LIST_LIVESTOCK_INFOS_FROM_CORRALS =
  "LIST_LIVESTOCK_INFOS_FROM_CORRALS";
export const LIST_LIVESTOCK_INFOS_FROM_FARM = "LIST_LIVESTOCK_INFOS_FROM_FARM";

export type LivestockDispatchAction =
  | {
      type: typeof LIST_FARM_WEIGHT_GAIN_CURVES;
      payload: { weightGainCurves: WeightGainCurve[] };
    }
  | {
      type: typeof LIST_LIVESTOCK_INFOS_FROM_CORRALS;
      payload: { infos: LivestockInfo[] };
    }
  | {
      type: typeof LIST_LIVESTOCK_INFOS_FROM_FARM;
      payload: { infos: LivestockInfoFromFarm[] };
    };

export const listLivestockInfosFromCorrals = (
  infos: LivestockInfo[]
): LivestockDispatchAction => {
  return {
    type: LIST_LIVESTOCK_INFOS_FROM_CORRALS,
    payload: { infos },
  };
};

export const listFarmWeightGainCurves = (
  weightGainCurves: WeightGainCurve[]
): LivestockDispatchAction => {
  return {
    type: LIST_FARM_WEIGHT_GAIN_CURVES,
    payload: { weightGainCurves },
  };
};

export const listLivestockInfosFromFarm = (
  infos: LivestockInfoFromFarm[]
): LivestockDispatchAction => {
  return {
    type: LIST_LIVESTOCK_INFOS_FROM_FARM,
    payload: { infos },
  };
};
